import { View } from 'react-native';
import styled from 'styled-components/native';

export const MealsList = styled(View)``;

export const MealItemWrapper = styled(View)<{ last?: boolean }>`
    margin-bottom: ${({ last }) => (last ? 0 : 12)}px;
`;
